import React, { useLayoutEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
export interface Props {column : any, order : any}
export const ListFilter:React.FC<Props> = ({column, order}) => {
    const location = useLocation()
    const path = location.pathname.split('/')
    const page : any = new URLSearchParams(location.search).get('page')||1;
    const navigate = useNavigate()
    const {contentsType} = useParams()
    const [filter, setFilter] = useState<any>([])
    const handleSort = (sortColumn : string) => {
        if(column === sortColumn){
            navigate(`${location.pathname}?page=${page}&keyword=${''}&column=${sortColumn}&order=${order === 'desc' ? 'asc' : 'desc'}`)
        }else{
            navigate(`${location.pathname}?page=${page}&keyword=${''}&column=${sortColumn}&order=desc`)
        }
    }
    useLayoutEffect(()=>{
        switch(contentsType){
            case '1' : setFilter(AnnouncementFilter); break;
            case '2' : setFilter(TechDocumentFilter); break;
            case '3' : setFilter(CatalogueFilter); break;
            case '4' : setFilter(VideoFilter); break;
            case 'inquiry' : setFilter(inquiryFilter); break;
            case 'faq' : setFilter(faqFilter); break;
            case 'adminStrator' : setFilter(AdminStratorFilter); break;
        }
    }, [contentsType])
    return(
        <>
        <thead>
            <tr>
                {path[2] === 'prCenter' && (contentsType === '1' || contentsType === '2') ? 
                <th>
                    <span>썸네일</span>
                </th> : ''
                }
                {filter.map((filter:any, index : number)=>{
                    const isShowSort = filter.column === '' ? '' : 'sort'
                    return(
                    <th key={index}>
                        <span className="sortWrap" onClick={()=>handleSort(filter.column)}>
                            {filter.title}
                            {column === filter.column ? 
                            <span className={`${isShowSort} ${order}`}></span> :
                            <span className={`${isShowSort}`}></span>
                            }
                        </span>
                    </th>
                    )
                })}
                {path[2]==='setting' ? 
                <th>수정</th> : ''
                }
            </tr>
        </thead>
        </>
    )
}

export const AnnouncementFilter = [
    {title : '보도유형', column : ''},
    {title : '제목', column : ''},
    {title : '등록일자', column : 'date'},
    {title : '공개여부', column : ''},
]

export const TechDocumentFilter = [
    {title : '자료유형', column : ''},
    {title : '제목', column : ''},
    {title : '등록일자', column : 'date'},
    {title : '공개여부', column : ''},
]

export const CatalogueFilter = [
    {title : '제목', column : ''},
    {title : '등록일자', column : 'date'},
    {title : '공개여부', column : ''},
]

export const VideoFilter = [
    {title : '제목', column : ''},
    {title : '등록일자', column : 'date'},
    {title : '공개여부', column : ''},
]

export const inquiryFilter = [
    {title : '상태', column : 'status'},
    {title : '문의유형', column : 'type'},
    {title : '문의제목', column : 'subject'},
    {title : '문의일자', column : 'date'},
]

export const faqFilter = [
    {title : '질문', column : 'subject'},
    {title : '공개여부', column : ''},
]

export const AdminStratorFilter = [
    {title : '관리자 이름', column : 'manager_name'},
    {title : '아이디', column : 'manager_login'},
    {title : '연락처', column : 'manager_mobile'},
    {title : '휴대전화', column : 'manager_phone'},
    {title : '이메일', column : 'manager_email'},
]